/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  ApplyReferralCodeRequest,
  ApplyReferralCodeResponse,
  ChangePasswordRequest,
  CreateUserFromJuniferRequest,
  CreateUserFromJuniferResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Apply referral code to user
 */
export const applyReferralCode = (
  id: number,
  applyReferralCodeRequest: ApplyReferralCodeRequest,
  options?: SecondParameter<
    typeof backofficeRequest<ApplyReferralCodeResponse>
  >,
) => {
  return backofficeRequest<ApplyReferralCodeResponse>(
    {
      url: `/user/${id}/applyReferralCode`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: applyReferralCodeRequest,
    },
    options,
  )
}
/**
 * @summary Change a user's password
 */
export const changePassword = (
  id: number,
  changePasswordRequest: ChangePasswordRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/user/${id}/changePassword`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changePasswordRequest,
    },
    options,
  )
}
/**
 * @summary Create a new user from Junifer
 */
export const createUserFromJunifer = (
  createUserFromJuniferRequest: CreateUserFromJuniferRequest,
  options?: SecondParameter<
    typeof backofficeRequest<CreateUserFromJuniferResponse>
  >,
) => {
  return backofficeRequest<CreateUserFromJuniferResponse>(
    {
      url: `/user/createFromJunifer`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createUserFromJuniferRequest,
    },
    options,
  )
}
export type ApplyReferralCodeResult = NonNullable<
  Awaited<ReturnType<typeof applyReferralCode>>
>
export type ChangePasswordResult = NonNullable<
  Awaited<ReturnType<typeof changePassword>>
>
export type CreateUserFromJuniferResult = NonNullable<
  Awaited<ReturnType<typeof createUserFromJunifer>>
>
